var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfterBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 28,
    height: 28,
    viewBox: "0 0 512 512",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00efd1",
    d: "M389.63,63.73V438.26a10,10,0,0,1-15.83,8.12L256,361.94,138.2,446.38a10,10,0,0,1-15.83-8.12V63.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083863",
    d: "M389.63,53.73H122.37a10,10,0,0,0-10,10V438.26a19.984,19.984,0,0,0,31.656,16.247L256,374.244l111.97,80.261a20,20,0,0,0,31.66-16.245V63.73A10,10,0,0,0,389.63,53.73Zm-10,384.522-117.8-84.44a10,10,0,0,0-11.652,0L132.37,438.26V73.73H379.63Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterBookmark);
export default __webpack_public_path__ + "static/media/after-bookmark.18c71784895e52df341746e9e8c0037f.svg";
export { ForwardRef as ReactComponent };